export const SERVICES = [
  {
    id: "refresh",
    name: "The Refresh",
    price: 15,
    tagline: "The quick turnaround",
    features: ["Exterior hand clean", "Midsole wipe-down", "Lace wash", "Deodorise treatment", "48h turnaround"],
  },
  {
    id: "deep",
    name: "The Deep Clean",
    price: 25,
    tagline: "Most booked",
    popular: true,
    features: [
      "Full hand wash, inside & out",
      "Midsole + sole deep scrub",
      "Lace & insole treatment",
      "Stain removal",
      "Deodorise + reshape",
    ],
  },
  {
    id: "revival",
    name: "The Full Revival",
    price: 40,
    tagline: "The full surgery",
    features: [
      "Everything in Deep Clean",
      "Suede & leather conditioning",
      "Crease care + whitening touch-up",
      "Protective hydrophobic coating",
      "Premium boxed return",
    ],
  },
];

export const TIME_SLOTS = ["09:00 - 12:00", "12:00 - 15:00", "15:00 - 18:00", "18:00 - 21:00"];

export const STATUS_FLOW = ["pending", "collected", "cleaning", "delivering", "completed"];
